import React, { Dispatch, SetStateAction } from 'react';
import styled from 'styled-components';
import { VirtualOfficeCard } from './VirtualOfficeCard';
import { UserVirtualOfficeLicence } from '../../../views/Settings/settings.types';

const Box = styled.div`
  height: 100%;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: 12px;
  grid-row-gap: 12px;

  @media (max-width: 800px) {
    display: flex;
    flex-direction: column;
  }
`;
interface VirtualOfficeGridProps {
  setSelected: Dispatch<SetStateAction<any>>;
  setIsOpen: Dispatch<SetStateAction<boolean>>;

  licences: UserVirtualOfficeLicence[];
}

export const VirtualOfficeGrid = ({
  setSelected,
  licences,
  setIsOpen
}: VirtualOfficeGridProps) => {
  return (
    <Box>
      {licences.map((plan, i) => (
        <VirtualOfficeCard
          key={i}
          plan={plan}
          setSelected={setSelected}
          setIsOpen={setIsOpen}
        />
      ))}
    </Box>
  );
};
